import {apiHost} from './env.config';
let prefix = apiHost;
// test: http://www.hxbtest.kuainiujinke.com/szfh/entrance

const api = {
    submitLogin: prefix + "v1/user/login",
    submitReg: prefix + "v1/user/register",
    changePhone: prefix + "v1/user/change-phone",
    changePhoneConfig: prefix + "v1/user/change-phone-config",
    phoneVerify: prefix + "api/qn/sms/send-verify-code",      // 发送短信验证码{总行}
    bankCardInfo: prefix + "v1/user/bank-card-info",   // 查询绑定的银行卡信息和二类户信息

    repaymentInfo: prefix + "v1/repayment/repayment-info",     // 我要还款-查询下一还款日的应还总额
    periodsInfo: prefix + "v1/repayment/plan-info",     // 查询某个还款日的还款详情
    planList: prefix + "v1/repayment/all-plan",     // 查询按期还款计划
    voluntaryRepay: prefix + 'v1/payment/voluntary-repay', // 主动还款

    payWay: prefix + 'v1/repayment/pay-way', // 获取支付方式
    paymentWithdraw: prefix + 'v1/payment/withdraw', // 转账到一类户

    bankBind: prefix + 'v1/bank/bind', // 绑定银行卡
    bankChange: prefix + '/v1/bank/change', // 更换银行卡
    supportBanks: prefix + "qn/receive-card/get-support-banks",    // 获取支持的银行

    queryQuota: prefix + 'v1/credit/query-quota', // 额度查询
    creditGetAddress:  prefix + "v1/credit/get-address",    // 获取提额居住地址
    creditSaveAddress:  prefix + "v1/credit/save-address",    // 保存提额居住地址
    creditList:  prefix + "v1/credit/list",    // 保存提额居住地址
    personalInsurance:  prefix + "v1/credit/personal-insurance",    // 提额寿险认证提交
    getInsuranceList:  prefix + "v1/credit/get-personal-insurance-list",    // 获取寿险公司列表
    reassessQuota: prefix + 'v1/credit/reassess-quota', // 重新获取额度, 重新评估

    getUserInfo: prefix + 'v1/individual/get-user-info', // 获取用户基本资料
    authList: prefix + "v1/individual/menu",     //借款认证列表： 0-未认证，1-已认证
    idCard: prefix + "v1/individual/save-ocr",    //借款认证-身份证认证

    loanResult: prefix + "v1/apply/grant-status",    //放款结果：repay-待还款即已放款, refuse-申请失败, grant_fail-放款失败
    historyList: prefix + "v1/apply/history",    // 历史订单
    applyIndex: prefix + "v1/apply/index",      //借款首页详情
    rateCalculate: prefix + "v1/apply/rate-calculate",      //还款计划试算
    applySave: prefix + "v1/apply/save",      //保存进件
    contractInfo: prefix + "v1/apply/contract-info",    // 借款成功合同

    operatorConfig: prefix + "v1/contact/operator-config",       // 获取运营商配置信息
    verifyCode: prefix + "v1/contact/verify-code",               // 运营商验证码信息
    operatorSave: prefix + "v1/contact/operator-save",           // 运营商确认授权
    checkResetPassword: prefix + "v1/contact/check-reset-password",         // 查询运营商密码是否可更改
    resetPassword: prefix + "v1/contact/reset-password",         // 重置运营商密码提交
    resetSendSms: prefix + "v1/contact/reset-send-sms",          // 发送重置运营商密码短信

    sendVerifyCode: prefix + "v1/sms/send-verify-code",      // 发送短信验证码(公用)
    siteIndex: prefix + "v1/site/index",    // 首页
    webankFaceid: prefix + "v1/webank/faceid",       // 人脸检测
    ocrIdentity: prefix + "v1/ocr/identity",       // 身份证OCR
    ocrBankcard: prefix + "v1/ocr/bankcard",       // 银行卡ocr
    wechatApi: prefix + "api/qn/wechat/sign",       // 微信签名
    wechatAuth: prefix + "api/qn/wechat/oauth",       // oauth 授权页面


    /*************************V1.5版本*******************************/
    v2RepaymentIndex: prefix + "v2/repayment/index", // 还款首页总览接口
    v2RepaymentRepayPlan: prefix + "v2/repayment/repay-plan", // 还款计划
    v2RepaymentExistProcessOrder: prefix + "v2/repayment/exist-process-order", // 是否有处理中的还款订单

    v2ApplySave: prefix + "v1/apply/save", // 确认借款
    v2ApplyIndex: prefix + "v2/apply/index", // 产品详情
    taxApplyIndex: prefix + "tax/apply/index", // 税银贷新加接口-产品详情
    v2ApplyWaitResult: prefix + "v2/apply/result", // 借款结果(等待页)
    v2QueryQuota: prefix + 'v2/apply/quota', // 额度查询

    v2SiteIndex: prefix + "v2/site/index", // site-index
    v2UserRegister: prefix + "v2/user/register",    // 注册
    v2UserFillInfo: prefix + "v2/user/fill-info",    // 注册补充
    v2UserInfo: prefix + 'v2/user/info',    // 获取用户信息{注册用}
    v2UserInfoMask: prefix + 'v2/user/user-info-mask',    // 获取用户信息
    v2FillCompany: prefix + "v2/user/fill-company",    // 注册第二页-公司信息

    v2ValidationResultIdentify: prefix + "v2/validation/result-identify",       // 获取身份证ocr认证结果
    v2ValidationResultFaceid: prefix + 'v2/validation/result-faceid',  // 获取人脸检测认证结果
    v2ValidationFaceid: prefix + 'v2/validation/faceid',  // 人脸检测
    v2ValidationIdentity: prefix + 'v2/validation/identity',  // 身份证OCR
    identityGetinfo: prefix + 'v2/wechat/faceid-result-sync',  // 微信活体提交

    /*************************V1.7版本*******************************/
    faqHot: prefix + 'v2/faq/hot-faq',  // 热门
    faqCategory: prefix + 'v2/faq/faq-category',  // 分类
    faqFaq: prefix + 'v2/faq/faq',  // 列表
    faqDetail: prefix + 'v2/faq/faq-detail',  // 详情

    /*************************V1.76版本*******************************/
    saveContacts: prefix + 'v1/individual/save-contacts',  // 保存紧急联系人

    /*************************V1.77版本*******************************/
    v2WechatFaceFailed: prefix + 'v2/wechat/face-failed',  // 人脸识别失败统计

    /*************************V1.0*******************************/
    fillWorkInfo: prefix + 'lj/user/fill-work-info',  // 补充用户的职业、工作地址、现居住地址
    getJobOption: prefix + 'lj/user/get-job-option',  // 用户的职业选项,
    userCouponAvailable: `${prefix}coupon/interest-free/repay-available`,  // 查询还款可用优惠券, 原有接口为lj/user/coupon-available，已弃用
    userCouponList: prefix + 'lj/user/coupon-list',  // 查询优惠券,
    couponPickUp: prefix + 'lj/coupon/pick-up',  // 优惠券领取,
    v2ValidationIdcardOcr: prefix + 'v2/validation/idcard-ocr',  // API调用身份证OCR


    showInterestFreeCoupon: `${prefix}coupon/interest-free/show`,  // 首借免息券展示
    reportInterestFreeCoupon: `${prefix}coupon/interest-free/report`,  // 免息券展示弹窗上报
    userAvailableInterestFreeCoupon: `${prefix}coupon/interest-free/user-available`,  // 借款免息券信息
    v2UserOuterMsg: prefix + "v2/user/outer-msg",      // 开他行卡二类户发的送短信验证码
    v2UserOuterCard2: prefix + "v2/user/outer-card2",      // 开通他行卡二类户
    v2UserInnerCode: prefix + "v2/user/inner-code",      // 是否行内卡

    /*************************V1.1对接小程序*******************************/
    v1WebankCallbackFaceid: prefix + 'v1/webank-callback/faceid',    // 小程序人脸识别结果跳转

    // 2020.3.24 更换绑定银行卡
    v2UserBindMsg: prefix + "v2/user/bind-msg",      //发送验证码

    // 2020.5.7 lpr网贷签约
    lprSiteIndex: prefix + "lpr/site/index",                        //首页
    lprUserInfo: prefix + "lpr/user/info",                          //用户信息
    lprUserRegister: prefix + "lpr/user/register",                  //注册
    lprUserMask: prefix + "lpr/user/lpr-user-mask",                 // 个人中心
    lprValidationIdentity: prefix + "lpr/validation/identity",      //身份证OCR
    lprValidationFaceid: prefix + "lpr/validation/faceid",          //lpr人脸
    lprValidationResultFaceid: prefix + "lpr/validation/result-faceid",          //lpr人脸结果
    lprSignList: prefix + "lpr/lpr-sign/list",                        //个人住房按揭贷款信息
    lprSignCheck: prefix + "lpr/lpr-sign/check",                      //签约状态
    lprSignFixPriceAttr: prefix + "lpr/lpr-sign/fix-price-arrt",      //定价日期和期限
    lprSignSign: prefix + "lpr/lpr-sign/sign",                        //签章
    lprSignSignList: prefix + "lpr/lpr-sign/sign-list",               //签约进度
    lprSignContractView: prefix + "lpr/lpr-sign/contract-view",       //合同展示

    // 2020.4.22 线下推广
    v2OfflinePromotionSave: prefix + "v2/offline-promotion/save",
    checkVerify: prefix + "v1/user/check-verify",      // 发送短信验证码

    farmerLoanIndex: prefix + 'nhd/apply/index',
    farmerLoanSave: prefix + 'nhd/apply/save',

    /**
     * 2021.06.15 客户经理管理-白名单(二期)
     *                  ↓
     * 2021.11.11 客户经理管理-白名单(多产品改造，修改接口前缀)
     */
    accountManagerHome: prefix + 'api/qn/account-manager/home', // 客户经理中心(进入首页时调用，判断客户经理是否已经绑定)
    accountPhoneVerify: prefix + 'api/qn/sms/send-verify-code', // 获取验证码
    accountManagerBind: prefix + 'api/qn/account-manager/bind', // 客户经理绑定
    accountManagerCenter: prefix + 'api/qn/account-manager/center', // 客户经理中心(进入客户经理中心页面，拉取用户信息)
    setVersionInfosToIsRead: prefix + 'api/qn/account-manager/set-version-infos-to-is-read', //  客户经理中心,设置已读更新提示
    accountManagerQrcode: prefix + 'api/qn/account-manager/qrcode', // 刷新客户经理二维码
    accountManagerList: prefix + 'api/qn/account-manager/list', // 客户管理
    meritsManagerList: prefix + 'api/qn/account-manager/merits-manager', // 绩效管理
    accountManagerOverdueUser: prefix + 'api/qn/account-manager/overdue-user', // 逾期客户
    accountManagerDetail: prefix + 'api/qn/account-manager/detail', // 客户详情

    // 2021.11.11 多产品
    qnWebankUrl: prefix + "api/qn/cert-ocr/webank-url", // 获取身份证OCR识别地址
    qnWebankResult: prefix + "api/qn/cert-ocr/webank-result", // 获取OCR结果
    qnProductList: prefix + "api/qn/site/product-list", // 多产品产品列表
    qnSaveCert: prefix + "api/qn/user/save-cert", // 保存身份信息认证
    qnRegisterOrLogin: prefix + "api/qn/user/register-or-login", // 登录/注册
    qnUserLogout: prefix + "api/qn/user/logout", // 退出
    qnSendVerifyCode: prefix + "api/qn/sms/send-verify-code", // 短信发送
    qnSignSign: prefix + "api/qn/sign/sign", // 签约接口
    qnSiteIndex: prefix + "api/qn/site/index", // 首页
    qnCerttaxUrl: prefix + "api/qn/user/certtax-url", // 税银贷-获取税务认证url
    qnGetCompany: prefix + "api/qn/user/get-company", // 税务认证成功之后 获取要申请的贷款企业
    qnFaceidWebankUrl: prefix + "api/qn/faceid/webank-url", // 获取人脸识别地址
    qnFaceidWebankResult: prefix + "api/qn/faceid/status", // 获取人脸识别结果
    qnReceiveCardBind: prefix + "api/qn/receive-card/bind", // 绑定银行卡
    qnRiskResult: prefix + "api/qn/sign/risk-result", // 获取授信结果
    qnRepaymentIndex: prefix + "api/qn/repayment/index", // 获取借款笔数、本月应还金额
    qnGetJobOption: prefix + "api/qn/user/get-job-option", // 获取用户工作信息
    qnGetContracts: prefix + "api/qn/user/contracts", // 拉取紧急联系人信息
    qnFillWorkInfo: prefix + "api/qn/user/fill-work-info", // 用户职业工作信息
    qnSaveContacts: prefix + "api/qn/user/save-contacts", // 保存紧急联系人
    qnApplyIndex: prefix + "api/qn/apply/index", // 用信申请首页
    qnRateCalculate: prefix + "api/qn/repayment/rate-calculate", // 还款试算-确认借款页面(查看还款计划)
    qnSaveLoan: prefix + "api/qn/apply/save-loan", // 确认借款保存借款单
    qnLoanResult: prefix + "api/qn/apply/loan-result", // 借款结果获取
    qnReceiveCardList: prefix + "api/qn/receive-card/list", // 用户收款卡列表
    qnApplyRefuseConfirm: prefix + "qn/user/apply-refuse-confirm", // 授托支付审核拒绝确认接口
    qnRepaymentCurrentPlan: prefix + "api/qn/repayment/current-plan", // 按期还款列表
    qnRepaymentList: prefix + "api/qn/repayment/advance-plan",     // 查询可提前还款列表
    qnRepaymentAssetDetail: prefix + "api/qn/repayment/schedule-detail", // 借款详情
    qnRepaymentRepayPlan: prefix + "api/qn/repayment/repay-plan", // 还款计划
    qnApplyDetail: prefix + "api/qn/apply/loan-detail", // 更多详情
    qnApplyHistory: prefix + "api/qn/apply/history", // 借款记录
    qnRepaymentRepayOrderList: prefix + "api/qn/repayment/repay-order-list", // 还款记录
    qnContractInfo: prefix + "api/qn/apply/contract-info",    // 借款合同
    qnQayWay: prefix + 'api/qn/repayment/pay-way', // 获取支付方式
    qnVoluntaryRepay: prefix + 'api/qn/payment/voluntary-repay', // 主动还款
    qnOutBankBindMsg: prefix + 'qn/sms/out-bank-bind-msg', // 开通二类户获取验证码
    qnOuterCard2: prefix + 'qn/user/outer-card2',
    qnDebugGetIdentity: prefix + 'api/qn/debug/get-identity',
    qnDebugSetIdentity: prefix + 'api/qn/debug/set-identity',
    // 常见问题
    qnFaqHot: prefix + 'api/qn/faq/hot-faq',  // 热门
    qnFaqCategory: prefix + 'api/qn/faq/faq-category',  // 分类
    qnFaqFaq: prefix + 'api/qn/faq/faq',  // 列表
    qnFaqDetail: prefix + 'api/qn/faq/faq-detail',  // 详情
    // 个人中心
    qnBankCardInfo: prefix + "api/qn/user/bank-card-info",   // 查询绑定的银行卡信息和二类户信息
    qnUserInfoMask: prefix + 'api/qn/user/user-info-mask',    // 获取用户信息
    qnUserInfo: prefix + 'api/qn/user/info',    // 获取用户信息{注册用}
    qnUserBindMsg: prefix + "api/qn/user/bind-msg",      //发送验证码
    qnUserFillInfo: prefix + "api/qn/user/fill-info",    // 确认更换银行卡
    qnPaymentWithdraw: prefix + 'api/qn/payment/withdraw', // 转账到一类户
    qnUserUploadUseWitness: prefix + 'api/qn/user/upload-use-witness',  // 用款凭证图片上传
    // 结清证明
    qnSendMsg: prefix + "api/qn/clearance-certificates/send-sms",      //结清证明获取验证码
    qnVerifyUser: prefix + "api/qn/clearance-certificates/verify-user",    // 结清证明校验用户数据
    qnClearanceCertificates: prefix + 'api/qn/clearance-certificates/clearance-certificates', // 结清证明列表
    qnCreateClearanceCertificates: prefix + 'api/qn/clearance-certificates/create-clearance-certificates',  // 结清证明生成pdf
    // 多渠道共债
    qnCheckAmount: prefix + 'api/qn/apply/check-amount',
    // 获取已绑卡信息
    qnUnifyCardList: prefix + 'api/qn/receive-card/unify-card-list',
    // 统一支付短信发送
    qnUnifySendSms: prefix + "api/qn/receive-card/unify-send-sms",
    // 统一支付绑定银行卡
    qnCardUnifyBind: prefix + "api/qn/receive-card/unify-bind",
    // 根据卡号前缀获取银行卡信息
    qnGetUnifyCardInfo: prefix + "api/qn/receive-card/get-card-info-on-prefix",
    // 统一支付支持的银行列表
    qnUnifySupportBanks: prefix + "api/qn/receive-card/unify-support-card-list",
    // 校验输入卡是否本行卡
    qnCheckCardInner: prefix + 'api/qn/receive-card/check-card-is-inner',
    // 获取一类卡余额
    qnGetCardInfo: prefix + 'api/qn/receive-card/get-card-info',
    // 获取当前绑定卡是否是本行卡
    qnCheckBindCardInner: prefix + 'api/qn/receive-card/check-bind-card-is-inner',
    // 发起二类户转入
    qnCardIntoCardII: prefix + 'api/qn/payment/card-into-cardii',
    // 校验修改手机号
    qnCheckUserMobile: prefix + 'api/qn/user/check-user-info-with-mobile',
    // 修改手机号
    qnChangeUserMobile: prefix + 'api/qn/user/change-user-phone',
    qnUserGetWechatInfo: prefix + 'api/qn/user/get-wechat-user-info',
    qnCheckVerifyCode: prefix + 'api/qn/sms/check-mobile-verify-code',

    // 校验该设备是否在西安市、咸阳市、蓝田县、周至县境内
    qnPositionCheckLbs: prefix + "api/qn/position/check-lbs",
    //校验当前申请客户的身份证地址、居住地址及工作地址2是否有一项满足在陕西省境内
    qnPositionCheckLbsCustomer: prefix + "api/qn/position/check-lbs-customer",
    //判断是否是共用卡和农信卡
    checkBindCardIsXh: prefix + "api/qn/receive-card/check-bind-card-is-xh",
    
};
export default api;



// WEBPACK FOOTER //
// ./src/common/js/api.js